<template>
  <div class="module-wrapper linebottomg"
  style="margin-right: 9px; padding-right: 0px;"
  v-if="list">
    <div class="holdTitleVma"
    id="managerHead">基金经理
      <div class="holdTitleVmamore" @click="clickMore">
        历任基金经理
        <img src="@/assets/right-arrow-gray.png"
         alt=""
         class="right-arrow"/>
      </div>
    </div>
    <div :class="[list.length > 1 ? 'manager-info' : 'manager-infoonlyone']"
    v-for="(item, index) in list" :key="index" @click="clickIcon(item)">
      <div>
        <div class="manager" >
          <img class="manager-img"
           :src="getManagerImage(item)" alt />
          <div class="maMain">
            <div class="topm">
              <div class="manager-name">{{item.names}}</div>
              <div class="manager-b" v-if="item.HJ_JN > 0">
                <img src="@/assets/jnbac.png" alt="" class="manager-b-m">
                <div class="manager-con">金牛基金经理</div>
                </div>
            </div>
            <div class="botm">
              {{item.cydays}}
            </div>
          </div>
        </div>
      </div>
      <div class="linebtwtop" >
        <div class="linebtwl">本基金任期</div>
        <div class="linebtwr">任职回报</div>
      </div>
      <div class="linebtw" >
        <div class="linebtwl-b">
          {{item.time}}
          <span class="mageTime">{{item.days}}</span>
        </div>
        <div :class="['manager-rate', `${upDown(item.rate)}`]">{{confPer(item.rate)}}</div>
      </div>
      <div class="touziln" v-if="item.tzln !== '--' && list && list.length <= 2">
        <img src="@/assets/jjjltipicon.png" alt="" class="touzilnwzimg">
        <span class="touzilnwz">{{item.tzln}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import StoreManger from '@/utils/FundHQJHManger';
// import dataModel from '@/model/fundmanager.model';
import {
  detailPushPage,
} from '@/utils/nativeBridge';
import defoultImg from '@/assets/avator.png';

export default {
  name: 'FundManager',
  components: {
  },
  data() {
    return {
      isShow: true,
      list: [],
      nativeData: {},
      fundCode: '',
      fundType: '',
    };
  },
  computed: {},
  created() {
    this.render();
  },
  mounted() {
    // this.render();
  },
  methods: {
    clickIcon(item) {
      detailPushPage({
        type: '2',
        url: `fund://mp.1234567.com.cn/weex/d450a3216d9349cf8a3c5c5ccde5901c/pages/personalHome/profileHomePage?managerId=${item.mid}`,
      });
      // pz.jjjl.jjjl.click
      this.reportMonitor({
        eventName: 'pz.jjjl.jjjl.click',
      });
    },
    render() {
      this.list = this.configHDDataToShowData(StoreManger.getFundJJJLNew());
    },
    configHDDataToShowData(datas) {
      if (datas && Object.prototype.toString.call(datas) === '[object Array]' && datas.length > 0) {
        const item = datas[0];
        const {
          MANGER,
        } = item;
        const mList = [];
        if (MANGER) {
          MANGER.forEach((element) => {
            const {
              DAYS,
              FEMPDATE,
              LEMPDATE,
              PENAVGROWTH,
            } = element;
            // 日期
            const daysInt = parseInt(DAYS, 10);
            let str = '';
            if (daysInt < 365) {
              str += (`${daysInt}天`);
            } else if (daysInt === 365) {
              str += ('1年');
            } else {
              str += (`${parseInt(daysInt / 365.0, 10)}年又${daysInt % 365}天`);
            }
            str += '';
            let days = str;
            if (!DAYS) {
              days = '--';
            }
            // 从业
            const cydaysInt = parseInt(element.TOTALDAYS, 10);
            let cystr = '从业';
            if (cydaysInt < 365) {
              cystr += (`${cydaysInt}天`);
            } else if (cydaysInt === 365) {
              cystr += ('1年');
            } else {
              cystr += (`${parseInt(cydaysInt / 365.0, 10)}年又${cydaysInt % 365}天`);
            }
            cystr += '';

            let pjrate = '--';
            if (element.YIELDSE) {
              if (element.YIELDSE === '--') {
                pjrate = '--';
              } else {
                pjrate = `${parseFloat(element.YIELDSE).toFixed(2)}%`;
              }
            }
            cystr += `，年均回报${pjrate}`;
            const cydays = cystr;
            // 名称
            const names = element.MGRNAME ? element.MGRNAME : '--';
            // 图片
            const icons = element.NEWPHOTOURL ? element.NEWPHOTOURL : '--';
            // mid
            const mid = element.MGRID ? element.MGRID : '--';
            // isINOFFICE
            const isINOFFICE = element.ISINOFFICE ? element.ISINOFFICE : '--';
            // INVESTMENTIDEAR
            const tzln = element.INVESTMENTIDEAR ? element.INVESTMENTIDEAR : '--';
            // 时间
            let timeStr = `${FEMPDATE}`;
            if (FEMPDATE && FEMPDATE.length > 10) {
              timeStr = `${FEMPDATE.substr(0, 10)}`;
            }
            let endtimeStr = `${LEMPDATE}`;
            if (LEMPDATE && LEMPDATE.length > 10) {
              endtimeStr = `${LEMPDATE.substr(0, 10)}`;
            }
            if (!LEMPDATE || LEMPDATE.length === 0 || LEMPDATE === '--') {
              timeStr += '至今 ';
            } else {
              timeStr += `~${endtimeStr}`;
            }
            let time = timeStr;
            if (!FEMPDATE && !LEMPDATE) {
              time = '--';
            }
            // rate
            let rate = '--';
            if (PENAVGROWTH) {
              if (PENAVGROWTH === '--') {
                rate = '--';
              } else {
                rate = `${parseFloat(PENAVGROWTH).toFixed(2)}`;
              }
            }
            // HJ_JN
            let HJ_JN = 0;
            if (element.HJ_JN) {
              HJ_JN = element.HJ_JN;
            }
            mList.push({
              rate,
              time,
              isINOFFICE,
              mid,
              icons,
              names,
              days,
              tzln,
              cydays,
              HJ_JN,
            });
          });
        }
        if (mList.length > 0) {
          window.guildtime = `${mList[0].time} ${mList[0].days}`;
          window.guildRate = `${mList[0].rate}`;
        }
        return mList;
      }
      return [];
    },
    fetchRequest() {
      return new Promise((resolve) => {
        const resData = this.configHDDataToShowData(StoreManger.getFundJJJL());
        resolve(resData);
      });
    },
    checkData(data) {
      return (data && Object.prototype.toString.call(data) === '[object Array]' && data.length > 0);
    },
    handleDefault() {
      // this.pageData = dataModel.objectArrayWithKeyValuesArray([{}], [{}]);
    },
    confPer(value) {
      // eslint-disable-next-line use-isnan
      if (value === '--') {
        return '--';
      }
      if (Number.isNaN(value)) {
        return '--';
      }
      const newV = parseFloat(value);
      return `${newV.toFixed(2)}%`;
    },
    upDown(value) {
      const newV = parseFloat(value);
      if (newV > 0) {
        return 'red';
      }
      if (newV < 0) {
        return 'green';
      }
      return 'gray';
    },
    getManagerImage(item) {
      if (item) {
        if (item.icons && item.icons !== '--') {
          const curTime = new Date().getTime();
          const url = `${item.icons}?r=${curTime}`;
          console.log('getManagerImage');
          console.log(url);
          return url;
        }
      }
      return defoultImg;
    },
    clickMore() {
      const baseInfo = StoreManger.getFundJJXQ();
      const code = StoreManger.getFundJJXQCODE(baseInfo);
      detailPushPage({
        appId: 'b34ccfc4ed9a4af4a4880fee485cf417',
        url: '/pages/FundManagerList',
        params: {
          FCODE: code,
        },
      });
      this.reportMonitor({
        eventName: 'pz.xx.jjjl',
      });
    },
  },
};
</script>

<style scoped lang="less">
.holdTitleVmamore{
  display: flex;
  align-items: center;
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #666666;
  letter-spacing: 0;
  line-height: normal;
}
.holdTitleVma{
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #666666;
  letter-spacing: 0;
  line-height: normal;
  flex-direction: row;
  margin-bottom: 20px;
}
.module-wrapper {
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  padding-bottom: 4px;
  margin-bottom: 36px;
}
.manager-info {
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
  margin-top: 30px;
}
.manager-infoonlyone {
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
  margin-top: 10px;

}
.linebtw{
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  display: flex;
  margin-bottom: 8px
}
.linebtwtop{
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  display: flex;
  margin-bottom: 8px
}
.linebtwl{
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #999999;
  text-align: left;
}
.linebtwl-b{
  font-family: DINAlternate-Bold;
  font-size: 32px;
  color: #000000;
  text-align: left;
  line-height: 50px;
}
.linebtwr{
  font-family: ≈;
  font-size: 28px;
  color: #999999;
  text-align: right;
}
.manager {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}

.manager-img {
  width: 120px;
  height: 120px;
  border-radius: 60px;
  object-fit: cover;
}

.manager-name {
  font-family: PingFangSC-Regular;
font-size: 32px;
color: #000000;
text-align: justify;
line-height: 32px;
  margin-left: 20px;
  font-weight: bold;
}

.manager-data {
  display: flex;
  flex-direction: column;
}

.manager-rate {
  font-family: DINAlternate-Bold;
  font-size: 32px;
  color: #ff0000;
  text-align: right;
}

.manager-date {
  font-size: 30px;
  color: #666666;
  text-align: right;
  line-height: 50px;
}
.right-arrow {
  margin-left: 5px;
  width: 34px;
  height: 34px;
}
.gray {
  color: @app-color-stay;
}
.red {
  color: @app-color-up;
}
.green {
  color: @app-color-down;
}
.touziln{
  border-radius: 8px;
  margin-bottom: 30px;
  line-height: 30px;
  display: -webkit-box;
 text-align: justify;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.touzilnwzimg{
  width: 40px;
  height: 40px;
  margin-bottom: -3px;
  margin-right: 10px;
}
.touzilnwz{
  padding: 24px 0;
 padding-bottom: 0;
 padding-top: 0px;
 font-size: 30px;
 color: #000000;
 text-align: justify;
 line-height: 30px;
 word-wrap:break-word;
}
.maMain{
  flex-direction: column;
  display: flex;
}
.topm{
  flex-direction: row;
  display: flex;
}
.manager-con{
  position: absolute;
  z-index: 99;
  font-family: PingFangSC-Regular;
  font-size: 24px;
  color: #FFFFFF;
  text-align: justify;
  line-height: 24px;
  height: 32px;
  top: 4px;
  left: 40px;
}
.manager-b{
  position: relative;
  display: flex;
  margin-left: 10px;
  // background: url("../assets/jnbac.png") no-repeat ;
  // background-size:contain;
}
.manager-b-m{
  width: 196px;
  height: 36px;
}
.botm{
margin-top: 10px;
margin-left: 20px;
font-family: PingFangSC-Regular;
font-size: 28px;
color: #666666;
text-align: justify;
line-height: 28px;
}
.mageTime{
  margin-left: 20px;
}
</style>
